import React from 'react';
import { ArcSocketContext, ChannelRequestEnum } from '@src/core/socket';

export const useFlightDroneProvider = () => {
  const { arcSocket, readyState } = React.useContext(ArcSocketContext);

  React.useEffect(() => {
    const socket = arcSocket();
    if (socket === null || socket.readyState !== WebSocket.OPEN) return;
    
    const payload = { type: ChannelRequestEnum.SUBSCRIBE_ALL_DRONES };
    socket.send(JSON.stringify(payload));
    
    return () => {
      const socket = arcSocket();
      if (socket === null || socket.readyState !== WebSocket.OPEN) return;
      const payload = { type: ChannelRequestEnum.UNSUBSCRIBE_ALL_DRONES };
      socket.send(JSON.stringify(payload));
    };
  }, [arcSocket, readyState]);
};